import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import About from "./Pages/About";
import Dashboard from "./Admin/Dashboard";
import Login from "./Admin/Login";
import PrivateRoute from "./Admin/PrivateRoute";
import Shop from "./Pages/Shop";
import ProductDetail from "./Pages/ProductDetail";
import Cart from "./Pages/Cart";
import Checkout from "./Pages/Checkout";
import Faq from "./Pages/Faq";
import BulkOrderPopup from "./Components/BulkOrderPopup";
import OrderSuccess from "./Pages/OrderSuccess";
import Contact from "./Pages/Contact";
import ScrollToHash from "./Components/ScrollToHash";
import UserLogin from "./Pages/UserLogin";
import Signup from "./Pages/Signup";
import Profile from "./Pages/Profile";


function App() {

  const location = useLocation();

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
     <BulkOrderPopup />

      {!isAdmin && <Navbar />}
      <ScrollToHash />

      <Routes>

        <Route path="/" element={<Home />} />
         <Route 
 path="/product/:id" 
 element={<ProductDetail />} 
/>
        <Route path="/about" element={<About />} />
        <Route path="/signup" element={<Signup />} />
<Route path="/Userlogin" element={<UserLogin/>} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/shop" element={<Shop />} />
        <Route
  path="/order-success"
  element={<OrderSuccess />}
/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />

        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

      </Routes>

      {!isAdmin && <Footer />}
    </>
  );
}

export default App;